<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

    <button @click="addMessage" value="Test Toast">Show Toast</button>
    <button @click="showModel = true">Show Modal</button>

    <ModalDefault v-model="showModel">
      <p>
        Modal Content
      </p>
    </ModalDefault>

    <v-row>
      <v-col cols="12" md="6">

        <CardComponent>
          <template v-slot:title>
            Währungsbadge
            <ToolTip>
              <template v-slot:title>
                Tooltip Title
              </template>
              <p>
                Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
              </p>
              <p>
                Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen. Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr bekannt ist dieser: The
              </p>
            </ToolTip>
          </template>
          <v-card-text>
            <CurrencyBadge currency="€" />
            Weit hinten, hinter den Wortbergen, fern der Länder Vokalien und Konsonantien leben die Blindtexte.
            Abgeschieden wohnen sie in Buchstabhausen an der Küste des Semantik, eines großen Sprachozeans.
          </v-card-text>
        </CardComponent>

      </v-col>
    </v-row>

    <v-btn @click="$openSidebar('exampleSidebar1')">Example Sidebar 1</v-btn>
    <v-btn @click="$openSidebar('exampleSidebar2')">Example Sidebar 2</v-btn>
    <v-btn @click="$closeSidebar">Close sidebar</v-btn>
    <v-btn @click="locale = locale === 'de' ? 'en' : 'de'">Toggle locale</v-btn>
    <span>Locale:&nbsp;{{locale}}&nbsp;{{$t('app.name')}}</span>

  </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import {injectToastMessageQueue} from "@/components/toast/toast";
import ModalDefault from "@/components/modal/ModalDefault";
import CardComponent from "@/components/form/CardComponent";
import CurrencyBadge from "@/components/info/CurrencyBadge";
import ToolTip from "@/components/info/ToolTip";
import {injectLocalizationData} from "@/plugins/localization";


export default {
  name: "InformationView",
  components: {ModalDefault, CardComponent, CurrencyBadge, ToolTip},
  setup(){
    const showModel = ref(false)
    const messageQueue = injectToastMessageQueue()
    function addMessage (e) {
      messageQueue.addMessage(e.target.value)
    }

    let localization = injectLocalizationData()
    localization.locale.value = 'en'

    return {
      showModel,
      addMessage,
      locale: localization.locale
    }
  }
}
</script>

<style scoped>

</style>
